import React from 'react';
import SEO from '../components/SEO';
import './LegalPages.css';

const RefundPolicy = () => {
  return (
    <>
      <SEO
        title="Refund Policy | Tech Update"
        description="Tech Update Refund Policy. Learn about our refund eligibility, request process, and terms for project cancellations and refunds."
        keywords="refund policy, money back guarantee, cancellation policy, refund terms"
        url="https://www.gettechupdate.com/refund-policy"
      />
      <div className="legal-page">
      <div className="legal-container">
        <h1>Refund Policy</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Overview</h2>
          <p>
            At Tech Update, we strive to deliver high-quality services that meet your expectations. This Refund Policy 
            outlines the terms and conditions under which refunds may be issued for our services.
          </p>
        </section>

        <section>
          <h2>2. Refund Eligibility</h2>
          <p>Refunds may be considered under the following circumstances:</p>
          <ul>
            <li>Service not delivered as agreed in the project contract</li>
            <li>Project cancellation before work commencement (subject to terms)</li>
            <li>Technical issues preventing service delivery</li>
            <li>Breach of contract by Tech Update</li>
          </ul>
        </section>

        <section>
          <h2>3. Refund Request Process</h2>
          <h3>3.1 Timeframe</h3>
          <p>
            Refund requests must be submitted within 7 days of project completion or service delivery. Requests 
            submitted after this period may not be eligible for a full refund.
          </p>

          <h3>3.2 How to Request</h3>
          <p>To request a refund, please contact us with the following information:</p>
          <ul>
            <li>Project reference number or invoice number</li>
            <li>Reason for refund request</li>
            <li>Supporting documentation (if applicable)</li>
            <li>Preferred refund method</li>
          </ul>
        </section>

        <section>
          <h2>4. Refund Calculation</h2>
          <p>Refunds will be calculated based on:</p>
          <ul>
            <li><strong>Work Completed:</strong> Amount proportional to work completed up to the refund request date</li>
            <li><strong>Non-Refundable Deposit:</strong> Initial deposit (typically 30-50%) is non-refundable</li>
            <li><strong>Administrative Fees:</strong> Processing fees may apply (up to 10% of refund amount)</li>
            <li><strong>Third-Party Costs:</strong> Any third-party expenses incurred are non-refundable</li>
          </ul>
        </section>

        <section>
          <h2>5. Processing Time</h2>
          <p>
            Once a refund request is approved, processing typically takes 5-10 business days. The refund will be 
            issued to the original payment method used for the transaction.
          </p>
        </section>

        <section>
          <h2>6. Non-Refundable Items</h2>
          <p>The following are not eligible for refunds:</p>
          <ul>
            <li>Initial project deposit (unless project is cancelled before work begins)</li>
            <li>Completed and delivered work that meets project specifications</li>
            <li>Third-party licenses, subscriptions, or services purchased on your behalf</li>
            <li>Work completed beyond the refund request date</li>
            <li>Services modified or customized per client's specific requirements</li>
          </ul>
        </section>

        <section>
          <h2>7. Project Cancellation</h2>
          <h3>7.1 Client-Initiated Cancellation</h3>
          <p>
            If you cancel a project after work has begun, you will be charged for all work completed up to the 
            cancellation date, plus any non-recoverable expenses.
          </p>

          <h3>7.2 Tech Update-Initiated Cancellation</h3>
          <p>
            If we cancel a project due to circumstances beyond our control, you will receive a full refund of any 
            payments made, minus work already completed.
          </p>
        </section>

        <section>
          <h2>8. Dispute Resolution</h2>
          <p>
            If you are not satisfied with our refund decision, please contact us to discuss your concerns. We are 
            committed to finding a fair resolution. If we cannot reach an agreement, you may pursue other legal 
            remedies available to you.
          </p>
        </section>

        <section>
          <h2>9. Special Circumstances</h2>
          <p>
            In exceptional circumstances, we may consider refunds outside the standard policy. These will be evaluated 
            on a case-by-case basis and require management approval.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            For refund requests or questions about this policy, please contact us:
          </p>
          <p>
            <strong>Email:</strong> info@gettechupdate.com<br />
            <strong>Phone:</strong> +91 8269277543<br />
            <strong>Subject Line:</strong> "Refund Request - [Project Reference Number]"
          </p>
        </section>
      </div>
    </div>
    </>
  );
};

export default RefundPolicy;

